var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTarget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9 3 C 9 1.343 10.343 0 12 0 L 12 0 C 13.657 0 15 1.343 15 3 L 15 9 C 15 10.657 13.657 12 12 12 L 12 12 C 10.343 12 9 10.657 9 9 Z",
    id: "a1000z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "a1001z"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1000z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1000z",
    fill: "#005AE0",
    clipPath: "url(#a1001z)",
    strokeWidth: 4,
    stroke: "hsl(0, 0%, 100%)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9 15 C 9 13.343 10.343 12 12 12 L 12 12 C 13.657 12 15 13.343 15 15 L 15 21 C 15 22.657 13.657 24 12 24 L 12 24 C 10.343 24 9 22.657 9 21 Z",
    id: "a1002z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "a1003z"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1002z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1002z",
    fill: "#005AE0",
    clipPath: "url(#a1003z)",
    strokeWidth: 4,
    stroke: "hsl(0, 0%, 100%)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 12 C 0 10.343 1.343 9 3 9 L 9 9 C 10.657 9 12 10.343 12 12 L 12 12 C 12 13.657 10.657 15 9 15 L 3 15 C 1.343 15 0 13.657 0 12 Z",
    id: "a1004z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "a1005z"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1004z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1004z",
    fill: "#005AE0",
    clipPath: "url(#a1005z)",
    strokeWidth: 4,
    stroke: "hsl(0, 0%, 100%)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12 12 C 12 10.343 13.343 9 15 9 L 21 9 C 22.657 9 24 10.343 24 12 L 24 12 C 24 13.657 22.657 15 21 15 L 15 15 C 13.343 15 12 13.657 12 12 Z",
    id: "a1006z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "a1007z"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1006z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1006z",
    fill: "#005AE0",
    clipPath: "url(#a1007z)",
    strokeWidth: 4,
    stroke: "hsl(0, 0%, 100%)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTarget);
export default __webpack_public_path__ + "static/media/icon-target.7390b2ad.svg";
export { ForwardRef as ReactComponent };